<template>
  <a :href="`/pages/${page.id}`">
    <div class="card">
      <RatioImage ratio="2:1" :src="imgProxy(page.seo_image || randomImage, rs = 'fill:400:200:1')"
        :tip="page.seo_title || page.title" class="card-img-top" />

      <div class="card-body">
        <h5 class="card-title text-truncate-3">{{ page.seo_title || page.title }}</h5>
        <p class="card-text text-truncate">{{ page.seo_description }}</p>
      </div>
    </div>
  </a>
</template>
<script setup>
import { computed } from 'vue'
import { dateFormat, imgProxy } from "../../utils"
import RatioImage from '../RatioImage.vue'

const props = defineProps({
  page: Object,
})

const randomImage = computed(() => {
  // 用 page.id 當 seed 保證同一頁面同一圖
  return props.page.seo_image || `https://picsum.photos/seed/page${props.page.id}/400/200`;
})
</script> 